export default __webpack_public_path__ + "static/joshua1-376d4a188759c16ecd74b0a95a82fe10.png";